import { Checkbox, CheckboxGroup, Stack, FormControl, FormLabel, FormErrorMessage } from "@chakra-ui/react";
import { getIn } from "formik";

const CustomCheckboxGroup = ({ formik, name, label, options, required }) => {
  const value = getIn(formik.values, name) || [];
  const error = getIn(formik.errors, name);
  const touched = getIn(formik.touched, name);

  const handleChange = (values) => {
    // Set the value and trigger validation
    formik.setFieldValue(name, values, true);
  };

  return (
    <FormControl isInvalid={touched && Boolean(error)} isRequired={required}>
      <FormLabel>{label}</FormLabel>
      <CheckboxGroup value={value} onChange={handleChange}>
        <Stack spacing={4} direction="row" flexWrap="wrap">
          {options.map((option) => (
            <Checkbox key={option.value} value={option.value}>
              {option.label}
            </Checkbox>
          ))}
        </Stack>
      </CheckboxGroup>
      <FormErrorMessage>{error}</FormErrorMessage>
    </FormControl>
  );
};

export default CustomCheckboxGroup;